module.exports = {"attributes":{"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.9744 11C15.018 11 11 15.018 11 19.9744C11 24.9308 15.018 28.9488 19.9744 28.9488C22.0921 28.9488 24.0384 28.2153 25.5733 26.9885L31.2917 32.7078C31.6822 33.0983 32.3154 33.0984 32.7059 32.7079C33.0965 32.3174 33.0965 31.6842 32.706 31.2936L26.9876 25.5744C28.2149 24.0394 28.9488 22.0926 28.9488 19.9744C28.9488 15.018 24.9308 11 19.9744 11ZM13 19.9744C13 16.1225 16.1225 13 19.9744 13C23.8262 13 26.9488 16.1225 26.9488 19.9744C26.9488 23.8262 23.8262 26.9488 19.9744 26.9488C16.1225 26.9488 13 23.8262 13 19.9744Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
